import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20warm%20gradient%20background%20with%20soft%20glowing%20orbs%2C%20deep%20crimson%20and%20amber%20tones%2C%20fluid%20organic%20shapes%2C%20dark%20elegant%20atmosphere%2C%20modern%20minimalist%20design%2C%20smooth%20gradients%2C%20no%20text%2C%20luxurious%20premium%20feel&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="91在线视频背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 text-center">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-white mb-5 tracking-wide">
          {heroData.titleLine1}
        </h1>
        <p className="text-xl md:text-2xl text-white/80 font-heading mb-5 tracking-wider">
          {heroData.titleLine2}
        </p>
        <p className="text-sm md:text-base text-white/60 max-w-[600px] mx-auto mb-10 leading-relaxed">
          {heroData.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={heroData.ctaLink}
            className="whitespace-nowrap px-8 py-3.5 bg-accent-500 text-white rounded-full text-base font-semibold hover:bg-accent-600 transition-all duration-200 inline-flex items-center gap-2 cursor-pointer"
          >
            <i className="ri-global-line text-lg"></i>
            {heroData.ctaText}
          </a>
          <a
            href={heroData.secondaryCtaLink}
            className="whitespace-nowrap px-8 py-3.5 border-2 border-white/30 text-white rounded-full text-base font-semibold hover:bg-white/10 transition-all duration-200 inline-flex items-center gap-2 cursor-pointer"
          >
            <i className="ri-download-2-line text-lg"></i>
            {heroData.secondaryCtaText}
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}